import { render, staticRenderFns } from "./Numbers.vue?vue&type=template&id=06d7c959&"
import script from "./Numbers.vue?vue&type=script&lang=js&"
export * from "./Numbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports